import { useSessionStorage } from 'react-use';

import { type ApiResult } from '@/lib/api-helpers/endpoint-manager';
import {
  type SalesforceApplicantInfo,
  type SalesforcePublicResponse,
} from '@/lib/salesforce';

export type ThankYouSession =
  | {
      applicantInfo: SalesforceApplicantInfo;
      magicLink?: string;
      userFirstName: string;
    }
  | undefined;

type SetterParams = {
  firstName: string;
  response: Response;
};

export const useThankYouSession = (): [
  ThankYouSession,
  (p: SetterParams) => Promise<ThankYouSession>
] => {
  const [thankYouSession, setThankYouSession] =
    useSessionStorage<ThankYouSession>('thankYouSession');

  // Define a different, public-facing setter that does some extra processing.
  const setThankYouSessionPublic = async ({
    response,
    firstName,
  }: SetterParams): Promise<ThankYouSession> => {
    const responseBody = (await response.json()) as ApiResult<
      { magicLink?: string } & SalesforcePublicResponse
    >;

    const sessionData = {
      ...responseBody.result,
      userFirstName: firstName,
    };
    setThankYouSession(sessionData);
    return sessionData;
  };

  return [thankYouSession, setThankYouSessionPublic];
};
